// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('PromoBadge')

function PromoBadge(props) {
  return (
    tag('a', {
      href: props.href,
      className: classNames(
        props.className,
        bem.block(props.id)
      ),
      title: props.title,
      onClick: props.onClick,
      onMouseOver: props.onMouseOver
    })
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  PromoBadge.propTypes = {
    // Values
    className: PropTypes.string,
    href: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    // Callbacks
    onClick: PropTypes.func.isRequired
  }
}

module.exports = PromoBadge
